<template>
  <div class="message-center-box" v-loading="loading">
    <div class="tabs-box">
      <div class="tab-item" :class="{ isActive: currentType === item.key }" v-for="item in panes" :key="item.key">
        <div class="tab-item-label" @click="changeTab(item)">{{item.label}}</div>
      </div>
      <div class="clear"></div>
    </div>
    
    <div class="message-list-box" @scroll="messageScroll">
      <div class="message-item" v-for="(item, i) in messageList" :key="i">
        <div class="message-icon" :class="{ isSys: item.messageType == '1', isOrder: item.messageType == '2', isAct: item.messageType == '3', isFollow: item.messageType == '4' }">
          <img v-if="item.messageType == '1'" :src="ossPath + '/pages/message/msg-sys.png'" alt="">
          <img v-if="item.messageType == '2'" :src="ossPath + '/pages/message/msg-order.png'" alt="">
          <img v-if="item.messageType == '3'" :src="ossPath + '/pages/message/msg-active.png'" alt="">
          <img v-if="item.messageType == '4'" :src="ossPath + '/pages/message/msg-follow.png'" alt="">
        </div>
        <div>
          <p class="message-title" :class="{unread: !item.whetherRead}">{{item.title}}</p>
          <p class="message-info">{{item.description}}</p>
          <div class="bottom-bar">
            <span>
              <!-- {{panes.find(v => item.messageType == v.key).label}} -->
              <!-- <el-divider direction="vertical"></el-divider> -->
              {{item.sendTime}}
            </span>
            <span class="action-btn" @click="checkDetails(item)">
              {{item.sourceType == '13' && !item.whetherCreateInquiryOrder ? '去下单' : '查看详情'}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
      <div style="text-align: center; line-height: 30px;" v-if="!messageList.length">
        <img style="padding-top: 90px; width: 160px; height: 160px" :src="ossPath + '/pages/home/empty-msg-icon.png'" alt="">
        <p>暂无新消息</p>
      </div>
    </div>
    <div class="action-bar">
      <div class="read-btn" @click="updateAll">全部已读</div>
      <div class="btn" @click="pathToMsgCenter">历史消息</div>
    </div>
  </div>
</template>

<script>
import {debounce} from "my-tools-kit";
import {ossPath, qrCodeImages} from "../../../../devParams"
import { mapState } from 'vuex'
export default {
  data() {
    return {
      ossPath,
      panes: [
        { label: '全部', key: null },
        { label: '系统消息', key: '1' },
        { label: '订单消息', key: '2' },
        { label: '活动消息', key: '3' },
        { label: '订阅消息', key: '4' }
      ],
      currentType: null,
      messageList: [],
      loading: false,
      pagingData: {
        curPage: 1, //当前页
        pageSize: 20, //分页数量
        totalPage: 1, //总页数
        loadMoreStatus: 'loadmore'
      }
    }
  },
  computed: {
    ...mapState(['Authorization'])
  },
  mounted() {
    this.initPage()
  },
  methods: {
    messageScroll:debounce(function(e){
      console.log(e, e.target.scrollTop)
      const { scrollTop, scrollHeight, clientHeight } = e.target
      console.log( scrollTop, scrollHeight, clientHeight)
      if (scrollTop + clientHeight + 1 >= scrollHeight) {
        console.log('滚动到底部了！')
        if (this.pagingData.loadMoreStatus === "nomore") return
        this.getMessageData()
      }
    },200,false),
    initPage() {
      this.messageList = [],
      this.loading = false
      this.pagingData = {
        curPage: 1, //当前页
        pageSize: 20, //分页数量
        totalPage: 1, //总页数
        loadMoreStatus: "loadmore", // loadmore loading nomore
      }
      this.init = true
      this.getMessageData()
    },
    changeTab(item) {
      this.currentType = item.key
      this.refreshUserInfo()
      this.initPage()
    },
    updateStatus(messageId) {
      const data = {
        userId: this.Authorization.userId
      }
      if (messageId) data.messageId = messageId
      this.axios.post('/systemNotificationSendInfo/updateNotificationStatus', data).then(res => {
        console.log(res)
        this.refreshUserInfo()
      })
      
    },
    refreshUserInfo() {
      if (this.Authorization && this.Authorization.token) {
        this.axios.get(`/user/getUserLoginInfo/1`).then(res => {
          this.$store.commit("addUserdata", res.data.data)
        }).catch(() => {
          this.$message.warning('获取当前用户最新信息失败')
        })
      }
    },
    getMessageData() {
      const data = {
        pageNum: this.pagingData.curPage, //当前页
        pageSize: this.pagingData.pageSize, //分页数量
        clientType: 1,
        readType: 2,
        messageType: this.currentType,
        userId: this.Authorization.userId
      }
      this.loading = true
      this.axios.post("/systemNotificationSendInfo/personalMessagePage", data).then(response => {
        const res = response.data
					console.log(res)
					if (res.data) {
						this.pagingData.totalCounts = parseInt(res.data.total) || 0;
						this.pagingData.totalPage = parseInt(res.data.pages) || 1;
						this.pagingData.curPage = (parseInt(res.data.current) || 0) + 1;
						let messageList = res.data.records || [];
						if (messageList.length) {
							this.messageList = this.messageList.concat(messageList);
						}
						if (this.messageList.length >= res.data.total) {
							this.pagingData.loadMoreStatus = "nomore";
						} else {
							this.pagingData.loadMoreStatus = "loadmore";
						}
					}
					this.loading = false;
				}).catch(res => {
					this.pagingData.loadMoreStatus = "loadmore";
					this.loading = false;
				})
    },
    checkDetails(item) {
      let pathData = {
        code: "",
        icon: "",
        level: "",
        name: "",
        nextNodes: "",
        parentId: "",
        resourceId: "",
      }
      if (item.sourceType == '1' || item.sourceType == '6') {
					// 首页
          this.$router.push('/')
				} else if (item.sourceType == '3' || item.sourceType == '5') {
					// 订单详情
          if (item.orderBusType == "1") {
            pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/FBAheader/FbaOrderDetails/${
              item.orderStatusType
            }/${item.innos}/${false}/${item.thirdNos}`;
            pathData.name = `${item.innos}详情`;
            this.$store.commit("mutationSelectTags", pathData);
            this.$router.push(
              `/index/PersonalCenter/Personalindex/PersonalCenter/FBAheader/FbaOrderDetails/${
                item.orderStatusType
              }/${item.innos}/${false}/${item.thirdNos}`
            );
          } else if (item.orderBusType == "2") {
            pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/PrivateAddrs/PrivateOrderDetails/${
              item.orderStatusType
              }/${item.orderId}`;
            pathData.name = `${item.innos}详情`;
            this.$store.commit("mutationSelectTags", pathData);
            this.$router.push(
              `/index/PersonalCenter/Personalindex/PersonalCenter/PrivateAddrs/PrivateOrderDetails/${
                item.orderStatusType
              }/${item.orderId}`
            );
          }
				} else if (item.sourceType == '2') {
					// 个人中心
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow`
          pathData.name = `我的钱包`
          this.$store.commit("mutationSelectTags", pathData)
          this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow')
				} else if (item.sourceType == '4') {
					// 轨迹查询
          this.$router.push(`/placeOrder/Trajectory?innos=${item.innos}`)
				} else if (item.sourceType == '7') {
					// 客服
          window.open(qrCodeImages.serviceUrl)
				} else if (item.sourceType == '8') {
					// 订阅国家
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/Mycollect`
          pathData.name = `线路订阅`
          this.$store.commit("mutationSelectTags", pathData)
          this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/Mycollect?type=first')
				} else if (item.sourceType == '9') {
					// 线路产品
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/Mycollect`
          pathData.name = `线路订阅`
          this.$store.commit("mutationSelectTags", pathData)
          this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/Mycollect?type=second')
				} else if (item.sourceType == '10' && item.linkUrl) {
          window.open(item.linkUrl)
				} else if (item.sourceType == '10' && !item.linkUrl) {
					// 详情
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/messageDetails/${item.id}`;
          pathData.name = `消息详情-${item.title}`;
          this.$store.commit("mutationSelectTags", pathData);
          this.$router.push(`/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/messageDetails/${item.id}`)
				} else if (item.sourceType == '11') {
					// 询盘
          if (item.messageType == '1') {
            // 系统通知 跳转至我发布的询盘
            pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/publishedInquiry`
            pathData.name = `我发布的询盘`
            this.$store.commit("mutationSelectTags", pathData)
            this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/publishedInquiry')
          } else if (item.messageType == '2') {
            // 订单通知 跳转至相应订单列表
            this.enterOrderList(item, pathData)
          }
				} else if (item.sourceType == '12') {
					// 回复询盘报价 跳转询盘详情
          pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/inquiryDetails/${item.linkId}`;
          pathData.name = `详情${item.linkId}`;
          this.$store.commit("mutationSelectTags", pathData);
          this.$router.push(`/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/inquiryDetails/${item.linkId}`)
				} else if (item.sourceType == '13') {
					// 选择询盘报价
          if (!item.whetherCreateInquiryOrder) {
            // 询盘报价未下单 对应的询盘下单页
            if (item.inquiryBusinessType == '1') {
              this.$router.push(`/placeOrder/inquiryTakeOrder?id=${item.linkId}`)
            } else {
              this.$router.push(`/placeOrder/inquiryTakeOrder/bulkCargo?id=${item.linkId}`)
            }
          } else {
            // 询盘报价已下单 跳转至相应订单列表
            this.enterOrderList(item, pathData)
          }
				} else if (item.sourceType == '14') {
          this.$router.push({ name: 'supplierJoin', params: { applyTypeCurrent: 'agency' } })
        }
        this.updateStatus(item.id)
        this.$emit('hide')
    },
    enterOrderList(item, pathData) {
      if (item.inquiryBusinessType == '1') {
        // 海运整柜
        pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/myOrder`
        pathData.name = `我的整柜询盘订单`
        this.$store.commit("mutationSelectTags", pathData)
        this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/inquiryManage/myOrder')
      } else {
        // 散货
        pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/MyOrder/MyOrderDetails`
        pathData.name = `我的订单`
        this.$store.commit("mutationSelectTags", pathData)
        this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/MyOrder/MyOrderDetails')
      }
    },
    updateAll() {
      this.updateStatus()
    },
    pathToMsgCenter() {
      let pathData = {}
      pathData.code = '/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/messageCenter';
      pathData.name = '消息中心';
      this.$store.commit("mutationSelectTags", pathData);
      this.$router.push('/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/messageCenter')
      this.$emit('hide')
      
      this.$root.Bus.$emit("refreshMessageCenter")
    }
  }
}
</script>

<style lang="scss" scoped>
.message-center-box {
  width: 510px;
}
.tabs-box {
  padding: 0 20px;
  border-bottom: 1px solid #EEEEEE;;
  .tab-item {
    float: left;
    padding: 0 10px;
    text-align: center;
    font-size: 0;
    color: #353535;
    font-weight: 400;
    cursor: pointer;
    transition: all .3s;
    &-label {
      padding-bottom: 12px;
      font-size: 16px;
      line-height: 22px;
    }
    &.isActive {
      font-weight: 600;
    }
    &.isActive::after {
      content: '';
      display: inline-block;
      height: 2px;
      width: 32px;
      background: #FF4D01;
      transition: all .3s;
    }
  }
  .clear {
    clear: both;
  }
}
.message-list-box {
   height: 370px;
   padding-bottom: 20px;
   overflow: auto;
  .message-item {
    margin: 0 20px;
    margin-top: 20px;
    display: flex;
    padding: 10px 12px;
    background: #F8F9FA;
    border-radius: 6px;
  }
  .message-icon {
    margin-right: 10px;
    // padding: 15px;
    // width: 60px;
    // height: 60px;
    // color: #333333;
    img {
      width: 30px;
      height: 30px;
    }
    // &.isSys {
    //   background: linear-gradient(360deg, rgba(18, 184, 250, .1) 0%, rgba(119, 214, 253, .1) 100%);
    // }
    // &.isAct {
    //   background: linear-gradient(42deg, rgba(255, 75, 40, .1) 0%, rgba(251, 183, 169, .1) 100%);;
    // }
    // &.isOrder {
    //   background: linear-gradient(360deg, rgba(65, 192, 71, .1) 0%, rgba(139, 221, 162, .1) 100%);
    // }
    // &.isFollow {
    //   background: linear-gradient(42deg, rgba(66,126,250, .1) 0%, rgba(165,181,251,0.1) 100%);
    // }
  }
  .message-title {
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    // &.unread::before {
    //   margin-right: 4px;
    //   content: '';
    //   display: inline-block;
    //   width: 6px;
    //   height: 6px;
    //   background: #FC2020;
    //   border-radius: 6px;
    //   vertical-align: middle;
    // }
  }
  .message-info {
    margin-top: 2px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bottom-bar {
    margin-top: 2px;
    line-height: 17px;
    font-weight: 400;
    color: #999999;
    font-size: 12px;
    // /deep/ .el-divider {
    //   margin: 0 2px;
    //   background-color: #999999;
    // }
    .action-btn {
      margin-left: 40px;
      color: #FF4D01;
      cursor: pointer;
    }
  }
}
.action-bar {
  padding: 0 20px;
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #141414;
  border-top: 1px solid #EEEEEE;;
  .read-btn {
    color: #FF4D01;
    cursor: pointer;
  }
  .btn {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/components/message-list-box.vue